import { REFERRAL_CREDIT_REWARD } from 'dragonmouse-shared/economy';
import { ReferralInfo } from 'dragonmouse-shared/interfaces';
import { useCallback, useState } from 'react';
import { trackReferralLinkCopied } from '../../../analytics';
import * as Base from '../styles';
import * as S from './styles';

type Props = {
	referralInfo: ReferralInfo;
};

const formatCredits = (credits: number): string => {
	return credits.toLocaleString();
};

const Referral = ({ referralInfo }: Props) => {
	const [copied, setCopied] = useState(false);
	const referralLink = `${window.location.origin}/?ref=${referralInfo.referralCode}`;

	const onCopy = useCallback(async () => {
		try {
			await navigator.clipboard.writeText(referralLink);
			setCopied(true);
			trackReferralLinkCopied();
			setTimeout(() => setCopied(false), 2000);
		} catch {
			// Fallback for older browsers
			const input = document.createElement('input');
			input.value = referralLink;
			document.body.appendChild(input);
			input.select();
			document.execCommand('copy');
			document.body.removeChild(input);
			setCopied(true);
			trackReferralLinkCopied();
			setTimeout(() => setCopied(false), 2000);
		}
	}, [referralLink]);

	return (
		<Base.Section>
			<Base.SectionHeader>
				<Base.SectionTitle>Refer & Earn Credits</Base.SectionTitle>
			</Base.SectionHeader>
			<S.Card>
				<S.Description>
					Share your link with friends. When they subscribe, you earn{' '}
					{formatCredits(REFERRAL_CREDIT_REWARD)} promotional credits within 24 hours.
				</S.Description>
				<S.ShareRow>
					<S.ShareInput value={referralLink} readOnly />
					<S.CopyButton onClick={onCopy}>{copied ? 'Copied!' : 'Copy Link'}</S.CopyButton>
				</S.ShareRow>
				<S.StatsRow>
					<S.StatItem>
						<S.StatLabel>Sign Ups</S.StatLabel>
						<S.StatValue>{referralInfo.totalReferrals}</S.StatValue>
					</S.StatItem>
					<S.StatItem>
						<S.StatLabel>Subscriptions</S.StatLabel>
						<S.StatValue>{referralInfo.subscribedReferrals}</S.StatValue>
					</S.StatItem>
					<S.StatItem>
						<S.StatLabel>Credits Earned</S.StatLabel>
						<S.StatValue>{formatCredits(referralInfo.creditsEarned)}</S.StatValue>
					</S.StatItem>
				</S.StatsRow>
			</S.Card>
		</Base.Section>
	);
};

export default Referral;
